import {fromJS, Map} from 'immutable';
import actions from '../../actions/payout.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {PayoutState} from './types';
import {AcceptanceStatus} from '../../../shared/types';
import {OfflinePaymentInfo} from '../../../shared/types/payout/PayoutPublic';
import {safelyToJS} from '../../selectors/utils';

const DEFAULT_PER_PAGE = 6;

// TODO: TEMPORARY UNTIL BACKEND IS HOOKED UP
const payoutState: PayoutState = {
    data: {},
    loadingData: false,
    closedAccount: {
        payoutType: null,
        acceptanceStatus: AcceptanceStatus.NO_ACTION
    },
    payoutReport: {
        reportList: [],
        loadingList: false,
        loadingDetail: false,
        isLimited: true,
        loadingMore: false
    },
    loadingAcceptance: false,
    payableAmounts: {
        amount: 0,
        vBucks: 0
    },
    loadingPayableAmounts: false,
    payoutAccount: ({} as any) as OfflinePaymentInfo,
    loadingOfflinePayment: false,
    date: ''
};

export const DEFAULT_STATE = fromJS(payoutState);

export const payoutReducer = (state: Map<keyof PayoutState, any> = DEFAULT_STATE, action) => {
    let newState = state;
    switch (action.type) {
        case actions.TYPES.GET_PAYOUT_REPORT: {
            return state.set('loadingData', true).set('date', action.payload.payoutPeriod);
        }
        case actions.TYPES.GET_PAYOUT_REPORT_COMPLETE: {
            return state.set('loadingData', false).set('data', action.payload.data);
        }
        case actions.TYPES.GET_PAYOUT_REPORT_FAILED: {
            return state.set('loadingData', false);
        }

        case actions.TYPES.SET_PAYOUT_DATE: {
            return state.set('date', action.payload);
        }

        case actions.TYPES.GET_PAYOUT_REPORT_LIST: {
            newState = newState.updateIn(['payoutReport', 'loadingList'], () => true);
            return newState;
        }
        case actions.TYPES.GET_PAYOUT_REPORT_LIST_COMPLETE: {
            const {elements, paging} = action.payload.data || {};
            if (elements && elements.length) {
                const currentList =
                    safelyToJS(newState.getIn(['payoutReport', 'reportList'])) || [];
                const isLimited = elements.length !== DEFAULT_PER_PAGE;
                newState = newState.updateIn(['payoutReport', 'isLimited'], () => isLimited);
                if (paging.start) {
                    newState = newState.updateIn(['payoutReport', 'reportList'], () => [
                        ...currentList,
                        ...elements
                    ]);
                } else {
                    newState = newState.updateIn(['payoutReport', 'reportList'], () => [
                        ...elements
                    ]);
                }
            }
            newState = newState.updateIn(['payoutReport', 'loadingList'], () => false);
            return newState;
        }
        case actions.TYPES.RESET_REPORT_LIST_PAGANTION:
            newState = newState.updateIn(['payoutReport', 'isLimited'], () => true);
            return newState;
        case actions.TYPES.GET_PAYOUT_REPORT_LIST_FAILED: {
            newState = newState.updateIn(['payoutReport', 'loadingList'], () => false);
            return newState;
        }

        case actions.TYPES.GET_PAYOUT_REPORT_DETAIL: {
            newState = newState.updateIn(['payoutReport', 'loadingDetail'], () => true);
            return newState;
        }
        case actions.TYPES.GET_PAYOUT_REPORT_DETAIL_COMPLETE: {
            const {data} = action.payload;
            const {paymentId} = data || {};
            const reportList = safelyToJS(newState.getIn(['payoutReport', 'reportList'])) || [];

            const reportItem = reportList.find(report => {
                const isMatched = report.paymentId === paymentId;
                if (isMatched) {
                    report.reportDetailInfo = action.payload.data.elements;
                }
                return isMatched;
            });

            if (reportItem) {
                newState.updateIn(['payoutReport', 'reportList'], () => reportList);
            }

            newState = newState.updateIn(['payoutReport', 'loadingDetail'], () => false);
            return newState;
        }
        case actions.TYPES.GET_PAYOUT_REPORT_DETAIL_FAILED: {
            newState = newState.updateIn(['payoutReport', 'loadingDetail'], () => false);
            return newState;
        }

        case actions.TYPES.GET_PAYOUT_ACCEPTANCE: {
            newState = newState.updateIn(['loadingAcceptance'], () => true);
            return newState;
        }
        case actions.TYPES.GET_PAYOUT_ACCEPTANCE_SUCCESS: {
            if (action.payload.data) {
                const {vBucks = 0, amount = 0} = action.payload.data;
                if (vBucks || amount) {
                    newState = newState.updateIn(['payableAmounts'], () => ({vBucks, amount}));
                }
                newState = newState.updateIn(['closedAccount'], () => action.payload.data);
            }
            newState = newState.updateIn(['loadingAcceptance'], () => false);
            return newState;
        }
        case actions.TYPES.GET_PAYOUT_ACCEPTANCE_FAILED: {
            newState = newState.updateIn(['loadingAcceptance'], () => false);
            return newState;
        }

        case actions.TYPES.GET_PAYABLE_AMOUNTS: {
            newState = newState.updateIn(['loadingPayableAmounts'], () => true);
            return newState;
        }
        case actions.TYPES.GET_PAYABLE_AMOUNTS_SUCCESS: {
            if (action.payload.data) {
                newState = newState.updateIn(['payableAmounts'], () => action.payload.data);
            }
            newState = newState.updateIn(['loadingPayableAmounts'], () => false);
            return newState;
        }
        case actions.TYPES.GET_PAYABLE_AMOUNTS_FAILED: {
            newState = newState.updateIn(['loadingPayableAmounts'], () => false);
            return newState;
        }

        case actions.TYPES.GET_OFFLINE_PAYMENT: {
            newState = newState.updateIn(['loadingOfflinePayment'], () => true);
            return newState;
        }
        case actions.TYPES.GET_OFFLINE_PAYMENT_SUCCESS: {
            if (action.payload.data) {
                newState = newState.updateIn(['payoutAccount'], () => action.payload.data);
            }
            newState = newState.updateIn(['loadingOfflinePayment'], () => false);
            return newState;
        }
        case actions.TYPES.GET_OFFLINE_PAYMENT_FAILED: {
            newState = newState.updateIn(['loadingOfflinePayment'], () => false);
            return newState;
        }

        case actions.TYPES.SAVE_OFFLINE_PAYMENT: {
            newState = newState.updateIn(['loadingOfflinePayment'], () => true);
            return newState;
        }
        case actions.TYPES.SAVE_OFFLINE_PAYMENT_SUCCESS: {
            newState = newState.updateIn(['payoutAccount'], () => action.payload.data);
            newState = newState.updateIn(['loadingOfflinePayment'], () => false);
            return newState;
        }
        case actions.TYPES.SAVE_OFFLINE_PAYMENT_FAILED: {
            newState = newState.updateIn(['loadingOfflinePayment'], () => false);
            return newState;
        }

        default: {
            return state;
        }
    }
};

export default dieselReducer('payout', payoutReducer);
